export default __webpack_public_path__ + "static/media/Poster1.d9bf05ee.jpg";